import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import {TextField} from 'rmwc/TextField';
import * as api from '../api/api';
import StatusMessage from '../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider, ListItemGraphic} from 'rmwc/List';

class SearchComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {
                searchTerm: '',
                criteria: ''
            }
        }
    }

    onInputChange = (evt) => {
        let data = Object.assign({}, this.state.data);
        data.searchTerm = evt.target.value;
        this.setState({data: data});
    }

    handleSearchCriteriaChange = (e) => {
        let data = Object.assign({}, this.state.data)
        data.criteria = e.target.value
        this.setState({data: data})
    }

    handleSearch = (e) => {
        e.preventDefault()
        if ((this.state.data.searchTerm === '') || (this.state.data.criteria === '')) {
            return
        }
        this.props.onHandleSearch(this.state.data.searchTerm, this.state.data.criteria, 1)
    }

    handleClear = (e) => {
        let data = Object.assign({}, this.state.data)
        data.searchTerm = ''
        data.criteria = ''
        this.props.onHandleClear(e)
        this.setState({data: data})
    }

    render() {
        let handleSearch = this.handleSearch
        let handleClear = this.handleClear
        return (
            <div> 
                <Select 
                    onChange={this.handleSearchCriteriaChange} 
                    value={this.state.data.criteria}
                    className="admin-reg-filter-section" >

                    <option>-- Select Criteria --</option>
                    <option value="user_name">User Name</option>
                    <option value="email">Email</option>
                    <option value="phone">Number</option>
                            
                </Select>
                <TextField className='admin-reg-filter-criteria' label="Search Term" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.data.searchTerm}/>
                <Button className="add-opportunity" onClick= {((e) => handleSearch(e))}> Search </Button>
                <Button className="add-opportunity" onClick= {((e) => handleClear(e))}> Clear </Button>
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent); 




// WEBPACK FOOTER //
// ./src/views/SearchComponent.jsx